import { LitElement, html, css } from "lit";
import { ProgressBar } from "./progress-bar";
import { centsToDollars } from "../../lib/utils";
export class FreeGiftProgressBar extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      .free-gift-progress {
        padding: 12px 20px;
        display: flex;
        column-gap: 12px;
        justify-content: space-between;
      }

      .free-gift-right-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .free-gift-progress p {
        font-size: 14px;
        text-align: center;
        margin: 0;

        line-height: 15.4px;
        letter-spacing: 0px;
        text-align: left;
      }

      .free-gift-progress-bar progress-bar {
        width: 100%;
        margin: 0 10px;
        font-size: 14px;
      }

      .free-gift-progress-bar {
        display: flex;
        align-items: center;
        width: 140px;
      }

      .free-gift-progress-bar .min-num,
      .free-gift-progress-bar .max-num {
        color: #978f90;
        font-size: 14px;
      }

      .free-gift-icon-container {
        width: 12px;
        height: 12px;
        display: flex;
      }

      @media (max-width: 767px) {
        .free-gift-progress p {
          font-size: 12px;
          line-height: 13px;
        }
        .free-gift-progress-bar {
          width: 95px;
        }
      }
    `,
  ];

  static properties = {
    subtotal: { type: Number },
    freeGiftMin: { type: Number, attribute: "free-gift-min" },
    lockedText: { type: String, attribute: "locked-text" },
    unlockedText: { type: String, attribute: "unlocked-text" },
  };

  connectedCallback() {
    super.connectedCallback();
    this.subtotal = this.subtotal ?? 0;
    this.freeGiftMin = this.freeGiftMin ?? 50;
    this.lockedText = this.lockedText ?? `to receive a free gift!`;
    this.unlockedText = this.unlockedText ?? `Free Gift Unlocked!`;
  }

  _renderFreeGiftText() {
    if (this.enabledText !== "false") {
      const spendToFreeShipping = Math.round(this.freeGiftMin - this.subtotal);
      if (this.subtotal > this.freeGiftMin) {
        return html`<p>${this.unlockedText}</p>`;
      } else {
        return html`<p>Add $${spendToFreeShipping} ${this.lockedText}</p>`;
      }
    }
  }

  render() {
    return html`
      <div class="free-gift-progress">
        ${this._renderFreeGiftText()}
        <div class="free-gift-right-container">
          <div class="free-gift-progress-bar">
            <progress-bar
              value=${Math.round((this.subtotal / this.freeGiftMin) * 100)}
            ></progress-bar>
          </div>
          <div class="free-gift-icon-container">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.13236 2.49999C1.82849 1.9321 2.08058 1.39139 2.43475 1.23752C2.66031 1.13953 3.07622 1.09994 3.71772 1.41501C4.1321 1.61853 4.62099 1.96241 5.17241 2.5L2.13236 2.49999ZM1.41619 2.50014C0.898057 0.851245 2.85896 -0.974206 6 2.39346C9.14104 -0.974206 11.1019 0.851245 10.5838 2.50014H11.3333C11.7015 2.50014 12 2.79862 12 3.16681V5.16681C12 5.535 11.7015 5.83347 11.3333 5.83347H10.6668V11.8332C10.6668 12.2014 10.3683 12.4999 10.0001 12.4999H6.33333V12.5001H5.66667V12.4999H2.00009C1.6319 12.4999 1.33343 12.2014 1.33343 11.8332V5.83347H0.666667C0.298477 5.83347 0 5.535 0 5.16681V3.16681C0 2.79862 0.298477 2.50014 0.666667 2.50014H1.41619ZM6.33333 11.8332H10.0001V5.83347H6.33333V11.8332ZM5.66667 5.83347V11.8332H2.00009L2.00009 5.83347H5.66667ZM6.33333 5.16657H10.0001H10.6668V5.16681H11.3333V3.16681L6.33333 3.16681V5.16657ZM5.66667 3.16681V5.16657H2.00009H1.33343V5.16681H0.666667V3.16681L5.66667 3.16681ZM9.56524 1.23752C9.91942 1.39139 10.1715 1.9321 9.86764 2.49999L6.82759 2.5C7.37901 1.96241 7.8679 1.61853 8.28228 1.41501C8.92378 1.09994 9.33969 1.13953 9.56524 1.23752Z"
                fill="#F93822"
              />
            </svg>
          </div>
        </div>
      </div>
    `;
  }
}
customElements.define("free-gift-progress", FreeGiftProgressBar);
